module.exports = __webpack_public_path__ + "static/img/pingtai.3260172a.png";